import { Selector } from '@ngxs/store';
import { BulkGroupItem } from '../control-panel/pricing-management/bulk-pricing/bulk-group-mgmt/bulk-group-interface';
import { PotentialIssuer } from '../issuer-interface';
import { IssuerState, IssuerStoreModel } from './issuer-state';

export class IssuerSelectors {
  @Selector([IssuerState])
  static isBulkPricingMode(state: IssuerStoreModel) {
    return state.isBulkPricingMode;
  }

  @Selector([IssuerState])
  static isEditMode(state: IssuerStoreModel) {
    return state.isEditMode;
  }

  @Selector([IssuerState])
  static isBulkNoteOverrideEnabled(state: IssuerStoreModel) {
    return state.isBulkNoteOverrideEnabled;
  }

  @Selector([IssuerState])
  static getSelectedPricingSource(state: IssuerStoreModel) {
    return state.selectedPricingSource;
  }

  @Selector([IssuerState])
  static getSelectedEntity(state: IssuerStoreModel) {
    return state.selectedEntity;
  }

  @Selector([IssuerState])
  static getSelectedEntityId(state: IssuerStoreModel) {
    return (plain = false): any => {
      if (state.isBulkPricingMode) {
        return {
          bulkPricingId: (state.selectedEntity as BulkGroupItem)?.bulkPricingId,
        }
      } else {
        const potentialIssuerKey = {
          issuerId: (state.selectedEntity as PotentialIssuer)?.issuer?.issuerId,
          currencyId: (state.selectedEntity as PotentialIssuer)?.currency.id
        }
        return plain ? potentialIssuerKey : { potentialIssuerKey };
      }
    }
  }

  @Selector([IssuerState])
  static getIssuers(state: IssuerStoreModel) {
    return state.issuers;
  }

  @Selector([IssuerState])
  static getIssuerById(state: IssuerStoreModel) {
    return (issuerId: number) => state.issuersMap.get(issuerId);
  }

  @Selector([IssuerState])
  static getCorpTickers(state: IssuerStoreModel) {
    return state.corpTickers;
  }

  @Selector([IssuerState])
  static getCountries(state: IssuerStoreModel) {
    return state.countries;
  }

  @Selector([IssuerState])
  static getCurrencies(state: IssuerStoreModel) {
    return state.currencies;
  }

  @Selector([IssuerState])
  static getSectors(state: IssuerStoreModel) {
    return state.sectors;
  }

  @Selector([IssuerState])
  static getRatings(state: IssuerStoreModel) {
    return state.ratings;
  }

  @Selector([IssuerState])
  static getProductTypes(state: IssuerStoreModel) {
    return state.productTypes;
  }

  @Selector([IssuerState])
  static getFairValueDrivers(state: IssuerStoreModel) {
    return state.fairValueDrivers;
  }

  @Selector([IssuerState])
  static getYieldFlags(state: IssuerStoreModel) {
    return state.yieldFlags;
  }

  @Selector([IssuerState])
  static getPricingSources(state: IssuerStoreModel) {
    return state.pricingSources;
  }

  @Selector([IssuerState])
  static getEsg(state: IssuerStoreModel) {
    return state.esg;
  }

  @Selector([IssuerState])
  static getSelectedIssuerCurrencies(state: IssuerStoreModel) {
    return state.selectedIssuerCurrencies;
  }
}
